import { AuthModule, ThirdPartySystem } from '$constants'
import { ThirdPartyConnectionInfo } from '$models'
import { getExternalSystemConnectionInfo } from '$utils'
import { StateCreator } from 'zustand'

interface SharedState {
  isLoading: boolean
}

export interface SharedSlice extends SharedState {
  setIsLoading: (newData: boolean) => void

  /**
   * Resets Shared Slice state
   */
  resetSharedSlice: () => void

  /**
   * Check external system connection
   * @param authModule Time or Stock
   * @param system The external system to check
   * @returns Promise resolving to ThirdPartyConnectionInfo
   */
  checkExternalSystemConnection: (
    authModule: AuthModule,
    system: ThirdPartySystem
  ) => Promise<ThirdPartyConnectionInfo>
}

const initialState: SharedState = {
  isLoading: false,
}

export const createSharedSlice: StateCreator<
  SharedSlice,
  [],
  [],
  SharedSlice
> = (set) => ({
  // State variables
  ...initialState,

  // State setters
  setIsLoading: (newData) => set({ isLoading: newData }),
  resetSharedSlice: () => set(initialState),

  checkExternalSystemConnection: async (
    authModule: AuthModule,
    system: ThirdPartySystem
  ): Promise<ThirdPartyConnectionInfo> => {
    return getExternalSystemConnectionInfo(system, authModule)
  },
})
